import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export interface Props {}

const GradingFilter: FC<Props> = () => {
	const { setValue, control } = useFormContext<ReportDetailForm>();

	const { showGradingReport } = useWatch({
		control,
		name: "filters"
	});

	const toggleShowGradingReport = (show: boolean) => {
		setValue("filters.showGradingReport", show);
		setValue("filters.userId", undefined);
	};

	return (
		<div data-testid="component.GradingFilter" className="w-fit my-6">
			<div className="flex flex-row bg-white border border-border p-1.5 rounded-xl shadow-xs inline-flex">
				<button
					className={[
						"px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200",
						!showGradingReport
							? "bg-primary text-white shadow-md shadow-primary/50"
							: "text-zinc-600 hover:text-zinc-800 hover:bg-white/80"
					].join(" ")}
					onClick={() => toggleShowGradingReport(false)}
				>
					Reporting
				</button>

				<button
					className={[
						"px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200",
						showGradingReport
							? "bg-primary text-white shadow-md shadow-primary/50"
							: "text-zinc-600 hover:text-zinc-800 hover:bg-white/80"
					].join(" ")}
					data-testid="set-complete-btn"
					onClick={() => toggleShowGradingReport(true)}
				>
					Grading
				</button>
			</div>
		</div>
	);
};

export default GradingFilter;
